import axiosInstance from "../helpers/axiosInstance"
import S3Client from '../helpers/s3Client'

export const PACKING_PROOF_CONFIG = {
  newMultipartUploadPath: '/packing-proof/new-multipart-upload',
  generateMultipartUploadPresignedUrlsPath: '/packing-proof/upload-presigned-urls',
  completeMultipartUploadPath: '/packing-proof/complete-upload',
  listFilesWithPrefixPath: '/packing-proof/list',
}

const MAX_CHUNK_SIZE = 5 * 1024 * 1024 // 5MB, note: parts must be min of 5MB except for the last part

export const uploadPackingProofVideo = async (orderId, videoBlob) => {
  console.log(`uploadPackingProofVideo start for order id ${orderId}`, videoBlob)
  const s3Client = new S3Client(PACKING_PROOF_CONFIG)
  await s3Client.createMultipartUpload(String(orderId), 5) // 5 presigned URLs

  const chunks = splitBlobIntoChunks(videoBlob)
  console.log(`uploadPackingProofVideo blob split into ${chunks.length} chunks`)

  // run uploadPart in parallel and wait for all to finish
  await Promise.all(
    chunks.map(async (chunk, index) => {
      await s3Client.uploadPart(chunk, index)
      console.log(`uploadPackingProofVideo uploaded chunk ${index + 1} of ${chunks.length} with size ${chunk.size} bytes`)
    }),
  )

  const completeMultipartUpload = await s3Client.completeMultipartUpload()
  console.log(`uploadPackingProofVideo completeMultipartUpload`, completeMultipartUpload)

  return completeMultipartUpload
}

const splitBlobIntoChunks = (blob, chunkSize = MAX_CHUNK_SIZE) => {
  const chunks = []
  let start = 0
  while (start < blob.size) {
    chunks.push(blob.slice(start, start + chunkSize))
    start += chunkSize
  }
  return chunks
}

export const listFilesWithPrefix = async (prefix) => {
  const s3Client = new S3Client(PACKING_PROOF_CONFIG)
  const objects = await s3Client.listFilesWithPrefix(prefix)
  return objects
}

export const downloadPackingProofVideo = async (path, filename) => {
  // Fetch the file as a blob and trigger download
  const response = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}${path}`, { responseType: 'blob' } )
  const blob = response.data
  const blobUrl = window.URL.createObjectURL(blob)

  const link = document.createElement("a")
  link.href = blobUrl
  link.setAttribute("download", filename || path.split("/").pop())
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(blobUrl)
  
  return true
}